module.exports = __webpack_public_path__ + "img/50332C_D98D79_955F52_AA7C6C-256px.0dd515d0.png";